import React from "react";
import { useNavigate } from "react-router-dom";
import { createFloor } from "adminApi/FloorApi/Floor";
import { validateForm } from "utils/validation";
import { FloorRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddFloorForm from "./Components/AddFloorForm";
import fields from "../json/FloorFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddFloor = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors } = useFormChange(initialValues, FloorRules);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        // Send plain JSON — no file uploads in this form
        async (formValues) => await createFloor({ data: formValues }),
        (vals) => {
            const err = validateForm(vals, FloorRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Floor created successfully"
    );

    return (
        <>
            {loadingSubmit && <Spinner isSpinner={true} />}
            <AddFloorForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Add Floor"
            />
        </>
    );
};

export default AddFloor;
